import { render } from "./FiltersShoulder.vue?vue&type=template&id=8efec3a8"
import script from "./FiltersShoulder.vue?vue&type=script&lang=js"
export * from "./FiltersShoulder.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/backoffice.callmewine.co.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__